/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M1.5 12C1.5 6.201 6.201 1.5 12 1.5A.75.75 0 0 0 12 0C5.3726 0 0 5.3726 0 12s5.3726 12 12 12 12-5.3726 12-12a.75.75 0 0 0-1.5 0c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 5.5c1.5247 0 2.9268.525 4.0354 1.404L21.4393 1.5H17.25a.75.75 0 0 1 0-1.5H24v6.75a.75.75 0 0 1-1.5 0V2.5607l-5.404 5.404A6.4725 6.4725 0 0 1 18.5 12c0 3.5899-2.9101 6.5-6.5 6.5S5.5 15.5899 5.5 12 8.4101 5.5 12 5.5ZM17.0607 8 16 6.9393l-4.2803 4.2804a.75.75 0 0 0 0 1.0606.75.75 0 0 0 1.0606 0L17.0607 8Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuExternalCIFilled'
);
